const {ccclass, property} = cc._decorator;

@ccclass
export default class water_course_mark extends cc.Component {
    start () {
        this.markAni();
    }

    markAni(){
        let tween = cc.tween(this.node).to(0.2,{angle:20,scale:1.1}).to(0.2,{angle:-20,scale:1});
        cc.tween(this.node).repeatForever(tween).start();
    }
}
